"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShelfPrevious = exports.ShelfNext = void 0;
var _themeGet = require("@styled-system/theme-get");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _helpers = require("../../helpers");
var _ChevronLeftIcon = _interopRequireDefault(require("@artsy/icons/ChevronLeftIcon"));
var _ChevronRightIcon = _interopRequireDefault(require("@artsy/icons/ChevronRightIcon"));
var _Clickable = require("../Clickable");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** ShelfNavigationProps */

var STATES = {
  hover: (0, _styledComponents.css)(["outline:0;color:", ";box-shadow:", ";"], (0, _themeGet.themeGet)("colors.black100"), _helpers.DROP_SHADOW),
  focus: (0, _styledComponents.css)(["outline:0;color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.brand")),
  disabled: (0, _styledComponents.css)(["opacity:0;cursor:default;"])
};
var Arrow = (0, _styledComponents.default)(_Clickable.Clickable).withConfig({
  displayName: "ShelfNavigation__Arrow",
  componentId: "myqxb5-0"
})(["height:50px;width:50px;display:flex;align-items:center;justify-content:center;cursor:pointer;user-select:none;transition:opacity 250ms,color 250ms,border-color 250ms,box-shadow 0.25s ease;color:", ";background-color:", ";border:1px solid ", ";border-radius:50%;pointer-events:auto;> svg{fill:currentColor;}", " &:hover{", "}&:focus{", "}&:disabled{", "}"], (0, _themeGet.themeGet)("colors.black60"), (0, _themeGet.themeGet)("colors.white100"), (0, _themeGet.themeGet)("colors.black5"), function (props) {
  return (0, _styledComponents.css)(["", " ", " ", ""], props.hover && STATES.hover, props.focus && STATES.focus, props.disabled && STATES.focus);
}, STATES.hover, STATES.focus, STATES.disabled);

/**
 * Default next button
 */
var ShelfNext = function ShelfNext(props) {
  return /*#__PURE__*/_react.default.createElement(Arrow, props, /*#__PURE__*/_react.default.createElement(_ChevronRightIcon.default, {
    width: 15,
    height: 15
  }));
};
exports.ShelfNext = ShelfNext;
ShelfNext.displayName = "ShelfNext";
/**
 * Default previous button
 */
var ShelfPrevious = function ShelfPrevious(props) {
  return /*#__PURE__*/_react.default.createElement(Arrow, props, /*#__PURE__*/_react.default.createElement(_ChevronLeftIcon.default, {
    width: 15,
    height: 15
  }));
};
exports.ShelfPrevious = ShelfPrevious;
ShelfPrevious.displayName = "ShelfPrevious";
//# sourceMappingURL=ShelfNavigation.js.map